import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../USER/Auth/AuthContext';
import { addFueling } from '../DB/supabaseServices';
import { Fuel, DollarSign, Map, Check, X } from 'lucide-react';
import Cleave from 'cleave.js/react';
import Swal from 'sweetalert2';
import { BryButton, BryCard } from '../UI/BryUI';
import './RegisterFueling.css';

function RegisterFueling({ onClose }) {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [litros, setLitros] = useState('');
  const [valor, setValor] = useState('');
  const [km, setKm] = useState('');
  const firstInputRef = useRef(null);

  useEffect(() => {
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!litros || !valor || !km) {
      Swal.fire('Atención', 'Por favor complete todos los campos.', 'warning');
      return;
    }

    setLoading(true);
    const fueling = {
      date: new Date().toISOString(),
      litros: parseFloat(litros),
      valor: parseFloat(valor),
      km: parseFloat(km),
    };

    try {
      await addFueling(currentUser.uid || currentUser.id, fueling);
      Swal.fire({
        title: '¡Registrado!',
        text: 'Carga de combustible guardada.',
        icon: 'success',
        confirmButtonColor: 'var(--bry-accent)'
      }).then(() => onClose());
    } catch (error) {
      console.error("Error:", error);
      Swal.fire('Error', 'No se pudo guardar: ' + error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4 animate-in fade-in duration-200">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <BryCard className="p-4 bg-gray-900 border-gray-800 flex flex-col gap-4">
          
          <div className="flex flex-col">
            <label className="text-xs font-semibold text-gray-400 mb-1 block">Litros</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Fuel size={16} className="text-[var(--bry-accent)]" />
              </div>
              <Cleave
                options={{ numeral: true, numeralDecimalScale: 2 }}
                placeholder="0.00"
                value={litros}
                onChange={(e) => setLitros(e.target.rawValue)}
                className="w-full pl-10 bg-gray-800 border border-gray-700 text-white text-sm rounded-lg focus:ring-[var(--bry-accent)] focus:border-[var(--bry-accent)] block p-2.5 outline-none transition-colors"
                htmlRef={(ref) => (firstInputRef.current = ref)}
              />
            </div>
          </div>

          <div className="flex flex-col">
            <label className="text-xs font-semibold text-gray-400 mb-1 block">Monto Pagado ($)</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <DollarSign size={16} className="text-[var(--bry-accent)]" />
              </div>
              <Cleave
                options={{ numeral: true, numeralDecimalScale: 2 }}
                placeholder="0.00"
                value={valor}
                onChange={(e) => setValor(e.target.rawValue)}
                className="w-full pl-10 bg-gray-800 border border-gray-700 text-white text-sm rounded-lg focus:ring-[var(--bry-accent)] focus:border-[var(--bry-accent)] block p-2.5 outline-none transition-colors"
              />
            </div>
          </div>

          <div className="flex flex-col">
            <label className="text-xs font-semibold text-gray-400 mb-1 block">Kilometraje Actual</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Map size={16} className="text-[var(--bry-accent)]" />
              </div>
              <Cleave
                options={{ numeral: true, numeralThousandsGroupStyle: 'none' }}
                placeholder="Ej: 12500"
                value={km}
                onChange={(e) => setKm(e.target.rawValue)}
                className="w-full pl-10 bg-gray-800 border border-gray-700 text-white text-sm rounded-lg focus:ring-[var(--bry-accent)] focus:border-[var(--bry-accent)] block p-2.5 outline-none transition-colors"
              />
            </div>
          </div>

        </BryCard>

        <div className="flex gap-3 mt-2">
          <BryButton type="button" variant="secondary" className="w-1/2 justify-center" onClick={onClose}>
            <X size={18} className="mr-2" /> Cancelar
          </BryButton>
          <BryButton type="submit" variant="primary" className="w-1/2 justify-center" disabled={loading}>
            {loading ? '...' : <><Check size={18} className="mr-2" /> Guardar</>}
          </BryButton>
        </div>
      </form>
    </div>
  );
}

export default RegisterFueling;
